import { setReferrer } from "@/helpers/localStorage";
import Header from "@features/header";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  processReferrer();

  return (
    <div className="dark:bg-black bg-gray-200 dark:text-white text-black h-screen p-[0.6250rem] flex flex-col gap-[0.625rem]">
      <Header />
      <main className="flex-1 overflow-auto flex">
        <Outlet />
      </main>
    </div>
  );
};

const processReferrer = () => {
  const url = new URL(window.location.href);
  const queryParams = url.searchParams;

  const ref = queryParams.get("ref");
  if (ref) {
    setReferrer(ref);
  }
};

export default MainLayout;
